module.exports = __webpack_public_path__ + "img/40_01_008_845.921486c6.jpg";